const Image = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 4.5A2.5 2.5 0 0 0 4.5 7v10A2.5 2.5 0 0 0 7 19.5h10a2.5 2.5 0 0 0 2.5-2.5V7A2.5 2.5 0 0 0 17 4.5zM5.5 7A1.5 1.5 0 0 1 7 5.5h10A1.5 1.5 0 0 1 18.5 7v10a1.5 1.5 0 0 1-1.5 1.5H7A1.5 1.5 0 0 1 5.5 17z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M15.846 16.5H8.308a.37.37 0 0 1-.354-.217q-.112-.217.05-.43l1.154-1.52a.4.4 0 0 1 .313-.162q.183 0 .313.143l1.427 1.724 2.293-2.898a.4.4 0 0 1 .323-.161.4.4 0 0 1 .323.162l2.02 2.713a.4.4 0 0 1 .03.429.37.37 0 0 1-.354.217"
    />
  </>
)
export default Image
